<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <div class="text-center mt-5 mb-10">
      <h1>{{ $t('users_associated_with_my_company') }}</h1>
    </div>
    <!-- USERS -->
    <div v-if="usersLoader" class="text-center">
      <Loader
        :size="'big'"
      />
    </div>
    <div v-else>
      <div v-if="user" class="mt-10">
        <UpsertUser
          v-if="openUpsertUser"
          :user="selectedUser"
          @user-created="getUsers"
          @user-updated="getUsers"
        />
        <!-- FILTERS -->
        <div class="d-flex align-items-center justify-content-between ms-2 my-5">
          <div class="d-flex align-items-center">
            <span class="me-4 text-color11 fw-500">{{ $t('filters') }}</span>
            <div class=" default-form">
              <span class="fw-bold form-label me-3 mb-0">{{ $t('status') }}:</span>
              <div class="custom-select custom-select-sm">
                <select class="form-control form-control-sm" v-model="filters.status" @change="search">
                  <option value="ACTIVE">{{ $t('status_type.active') }}</option>
                  <option value="INACTIVE">{{ $t('status_type.inactive') }}</option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="selectedUsers.length > 0" class="d-flex align-items-center">
            <span class="me-5">{{ selectedUsers.length }} selecionado(s)</span>
            <Button
              class="btn-danger me-5"
              v-if="filters.status === 'ACTIVE'"
              :disabled="selectedUsers.length === 0"
              @click="openDestroyUserModal()"
            >
              Desativar Selecionados
            </Button>
            <Button
              class="btn-success"
              v-if="filters.status === 'INACTIVE'"
              :disabled="selectedUsers.length === 0"
              @click="openActivateUserModal()"
            >
              Ativar Selecionados
            </Button>
          </div>
          <div v-else>
            <Button @click.prevent="openNewUser" class="btn-color10 me-2" v-b-tooltip.hover :title="$t('add')">
              {{ $t('add_user') }}
            </Button>
          </div>
        </div> <!-- END FILTERS -->
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer" id="kt_table_users">
                <thead>
                  <tr class="text-color11">
                    <th></th>
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('user_type') }}</th>
                    <th>{{ $t('email_verification') }}</th>
                    <th>{{ $t('two_factor_authentication') }}</th>
                    <th>{{ $t('status') }}</th>
                    <th width="100 text-center">
                      {{ $t('details') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(accountUser, index) in users" :key="index">
                    <!--begin::Checkbox-->
                    <td>
                      <!-- <div class="form-check form-check-sm form-check-custom form-check-solid" v-if="accountUser.id !== user.id">
                        <input class="form-check-input" type="checkbox" :value="accountUser.id" v-model="selectedUsers" />
                      </div> -->
                    </td>
                    <!--end::Checkbox-->
                    <td>
                      <div class="d-flex flex-column">
                        <span class="text-color9 mb-1 fw-600">{{ accountUser.name }}</span>
                        <span class="text-color11 mb-1 fw-500">{{ accountUser.email }}</span>
                      </div>
                    </td>
                    <td class="text-color11 mb-1 fw-500">{{ accountUser.role.slug | formatUserRole }}</td>
                    <td>
                      <div v-if="accountUser.is_email_verified" class="badge badge-light-success fw-bold p-3">{{ $t('verified') }}</div>
                      <div v-else class="badge badge-light-danger fw-bold p-3">{{ $t('not_verified') }}</div>
                    </td>
                    <td>
                      <div v-if="accountUser.use_2fa" class="badge badge-light-success fw-bold p-3">{{ $t('status_type.active') }}</div>
                      <div v-else class="badge badge-light-danger fw-bold p-3">{{ $t('status_type.inactive') }}</div>
                    </td>
                    <td>
                      <div v-if="accountUser.is_active" class="badge badge-light-success fw-bold p-3">{{ $t('status_type.active') }}</div>
                      <div v-else class="badge badge-light-danger fw-bold p-3">{{ $t('status_type.inactive') }}</div>
                    </td>
                    <td class="text-center">
                      <template v-if="accountUser.id === user.id">
                        <span>
                          ---
                        </span>
                      </template>
                      <template v-else>
                        <a href="#" @click.prevent="openEditUser(accountUser)" class="me-5"  v-b-tooltip.hover :title="$t('edit')">
                          <i class="fa fa-pencil font-size-small text-color11"></i>
                        </a>
                        <a href="#" @click.prevent="openDestroyUserModal(accountUser)" v-if="accountUser.is_active"  v-b-tooltip.hover :title="$t('disable')">
                          <i class="fa fa-trash font-size-small"></i>
                        </a>
                        <a href="#" @click.prevent="openActivateUserModal(accountUser)" v-b-tooltip.hover :title="$t('enable')" v-else>
                          <i class="fa fa-check font-size-small"></i>
                        </a>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--begin::Pagination-->
            <div class="d-flex flex-stack flex-wrap pt-10 ms-6">
              <div class="fs-6 fw-semibold text-gray-700">
                {{ $t('pagination', { from: from, to: to, totalItems: totalItems }) }}
              </div>
              <!--begin::Pages-->
              <b-pagination
                class="custom-pagination"
                v-if="totalPages > 1"
                v-model="page"
                :total-rows="totalItems"
                :per-page="itemsPerPage"
                :loading="usersLoader"
                @input="getUsers"
                hide-goto-end-buttons
              />
              <!--end::Pages-->
            </div>
            <!--end::Pagination-->
          </div>
        </div>
        <ActivateUserModal
          :user="selectedUser"
          @user-activated="getUsers"
        />
        <DestroyUserModal
          :user="selectedUser"
          @user-destroyed="getUsers"
        />
      </div>
    </div>
    <!-- END USERS -->
  </MainLayout>
</template>

<script>

import UsersService from '@/modules/users/services/users-service'
import { mapState } from 'vuex'

import ActivateUserModal from '@/components/users/ActivateUserModal'
import Button from '@/components/common/Button/Button'
import DestroyUserModal from '@/components/users/DestroyUserModal'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'
import UpsertUser from '@/components/users/UpsertUser'

export default {
  components: {
    ActivateUserModal,
    Button,
    DestroyUserModal,
    Loader,
    MainLayout,
    Shortcuts,
    UpsertUser
  },
  data () {
    return {
      filters: {
        status: 'ACTIVE'
      },
      from: 1,
      itemsPerPage: 0,
      openUpsertUser: false,
      page: 1,
      selectedUser: null,
      selectedUsers: [],
      to: 9,
      totalItems: 0,
      totalPages: 0,
      users: [],
      usersLoader: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('my_users')
    }
  },
  created () {
    if (this.user) {
      this.checkIfUserIsManager()
      this.getUsers()
    }
  },
  watch: {
    user (newUser) {
      this.checkIfUserIsManager()
      this.getUsers()
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * Check if user is manager or not
     */
    checkIfUserIsManager () {
      if (this.user.role.slug !== 'user-manager' && this.user.role.slug !== 'administrator') this.$router.push('/')
    },
    /**
     * Get company after update
     */
    async getCompany () {
      await UsersService.me()
    },
    /**
     * Get users associated with the company
     */
    async getUsers () {
      this.openUpsertUser = false
      this.usersLoader = true
      try {
        const users = await UsersService.getUsers({
          companyId: this.user.company.id,
          is_active: this.filters.status === 'ACTIVE' ? 1 : 0,
          page: this.page
        })
        this.users = users.data
        this.totalItems = users.meta.total
        this.totalPages = users.meta.last_page
        this.itemsPerPage = users.meta.per_page
        this.from = users.meta.from
        this.to = users.meta.to
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.usersLoader = false
    },
    /**
     * Open modal to activate user
     */
    openActivateUserModal (user = null) {
      this.selectedUser = user
      this.$bvModal.show('activate-user-modal')
    },
    /**
     * Open modal to destroy user
     */
    openDestroyUserModal (user = null) {
      this.selectedUser = user
      this.$bvModal.show('destroy-user-modal')
    },
    /**
     * Open to edit user
     */
    openEditUser (user) {
      this.selectedUser = user
      this.openUpsertUser = true
    },
    /**
     * Open  to create user
     */
    openNewUser () {
      this.selectedUser = null
      this.openUpsertUser = true
    },
    /**
     * Search
     */
    search () {
      this.page = 1
      this.selectedUsers = []
      this.users = []
      this.getUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
.company-logo {
  width: 50px;
  height: 50px;
  background-color: #eee;
  background-position: center;
  background-size: cover;
  -webkit-box-shadow: 0 0 3px 0 rgba(0,0,0,0.1);
  box-shadow: 0 0 3px 0 rgba(0,0,0,0.1);
}
</style>
